export const ALL_ADMIN_ROLES = ["super_admin", "admin", "executive"];

export const KAMUser = ["kam"];

export enum UserType {
    //
    VERIFICATION_ADMIN = "verification_admin",
    VERIFICATION_EXECUTIVE = "verification_executive",

    //
    FULLFILMENT_ADMIN = "fullfilment_admin",
    FULLFILMENT_EXECUTIVE = "fullfilment_executive",

    //
    IN_TRANSIT_ADMIN = "intransit_admin",
    IN_TRANSIT_EXECUTIVE = "intransit_executive",
    IN_TRANSIT_SUPPORT = "intransit_support",


    PP_PLACEMENT = "pp_placement_executive",
    PP_LOADING = "pp_loading_executive",
    PP_UNLOADING = "pp_unloading_executive"
}
export enum UserType {
    SUPER_ADMIN = "super_admin",
    INSIDER = "insider",
    DEVELOPER = "developer",

    USER = "user",
    KAM = "kam",
    ADMIN = "admin",
    TSM = "tsm",
    EXECUTIVE = "executive",
    RETENTION = "retention",

    TSO = "tso",
    TSO_DEMAND = "tso_demand",
    TSO_SUPPLY = "tso_supply",
    TSO_LORRY = "tso_lorry",
}

export enum PlivoTeam {
    VERIFICATION = "Verification",
    FULFILMENT = "Fulfilment",
    PP_PLACEMENT = "PP Placement",
    PP_LOADING = "PP Loading",
    PP_UNLOADING = "PP Unloading",
    // POST_PLACEMENT = "Post Placement",
    PP_SUPPORT = "PP Support",
    NIGHT_SHIFT = "Night Shift",
    CS_HELPDESK = "CS Helpdesk",
    RETENTION = "Retention",
    INSIDE_SALES_MEMBERSHIP = "Inside Sales Membership",
    INSIDE_SALES_CI = "Inside Sales CI"
}

const SUPER_USER_LIST = [UserType.SUPER_ADMIN, UserType.INSIDER, UserType.DEVELOPER];

export const USER_GROUP = {
    INTERNAL_USERS: [UserType.INSIDER, UserType.DEVELOPER],
    SUPER_USERS: SUPER_USER_LIST,
    ADMINS: [...SUPER_USER_LIST, UserType.ADMIN],
    TSO_V2: [UserType.TSO_SUPPLY, UserType.TSO_DEMAND]
};
export const ALLOWED_ACTION_BY_ROLES = {
    CUSTOM_PREFERENCE_VISIBILTY: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.RETENTION],
    UNASSIGNED_TICKET_ACTION: USER_GROUP.ADMINS,
    DEACTIVATE_LOAD: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.VERIFICATION_EXECUTIVE],
    LOAD_TICKET_PROCESS_AGENT: [...USER_GROUP.ADMINS, UserType.FULLFILMENT_EXECUTIVE, UserType.VERIFICATION_EXECUTIVE],
    CANCEL_TRIP: [...USER_GROUP.ADMINS],
    CANCEL_TRIP_LIMITED_TIME: [...USER_GROUP.ADMINS, UserType.IN_TRANSIT_EXECUTIVE],
    ALLOW_QUICK_LOGOUT: [...USER_GROUP.ADMINS, UserType.TSO],
    PP_EDIT: [...USER_GROUP.ADMINS, UserType.IN_TRANSIT_ADMIN]
};
